<template>
	<div>
		<div class="dashboard-main-box">
			<RightNav/>

			<div class="dashboard-dev dashboard-main sidebar-set-full bootstrap-fix widgets">
				<Header v-if="hasHeader" />
				<router-view :key="$route.path"/>
				<div class="hover-card-popper"></div>
			</div>

			<Modal />
			<Modal2 />
			<Modal3 />
		</div>
	</div>
</template>

<style lang="scss">
	@import "@/styles/app.scss";
	@import "@/styles/components/general.scss";
</style>

<script>

	let interval = setInterval(() => {
		if ( $('.bar-menu-dashboard').length ) {
			clearInterval(interval);

			let script = document.createElement("script");
			script.src =  process.env.VUE_APP_URL + '/app.js';
			document.body.appendChild(script);
		}
	}, 100);

	import RightNav from '@/views/partials/RightNav.vue'
	import Header from '@/views/partials/Header.vue'
	import Modal from '@/views/partials/Modal.vue'
	import Modal2 from '@/views/partials/Modal2.vue'
	import Modal3 from '@/views/partials/Modal3.vue'

	export default {
		name: 'App',

		components: {
			RightNav,
			Header,
			Modal,
			Modal2,
			Modal3,
		},

		data: function () {
			return {
				
			}
		},

		computed: {
			hasHeader: function () {
				return ( typeof this.$store.state.currentRoute.meta != 'undefined' ) ? this.$store.state.currentRoute.meta.header : false;
			}
		},

		methods: {
			
		}
	}
</script>